import { render, staticRenderFns } from "./PauseUnbranded.vue?vue&type=template&id=4a18b950"
import script from "./PauseUnbranded.vue?vue&type=script&lang=js"
export * from "./PauseUnbranded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports